import { get, map, chain, pick } from "lodash"
import { createSelector } from "reselect"
import { percentageFormatter } from "helpers/formatters/numbers"
import { getScanResult, getSummary, getCoverage } from "."

export const getTags = createSelector(
  [getSummary],
  (summary) => chain(summary)
    .get("items.averageTagCoverage.value")
    .map(({ label }) => label)
    .value(),
)

export const getUntaggedSecurities = createSelector(
  [getScanResult],
  (scanResult) => chain(scanResult)
    .get("scan.untaggedSecurities")
    .reduce((acc, securities, tag) => ([
      ...acc,
      ...map(securities, (security) => ({
        ...security,
        tagCategory: tag,
        // need a unique id for the table to work properly
        id: `${security.ticker}-${security.sedol}-${tag}-${security.lotId}`,
        identifier: security.ticker || security.sedol })),
    ]), [])
    .value(),
)

export const getTagRows = createSelector(
  [getCoverage, getTags],
  (coverage, tags) => {
    const rows = chain(coverage)
      .get("dates")
      .map((date) => map(tags, tag => ({
        // need a unique id for the table to work properly
        id: `${tag}-${date.date}`,
        tagCategory: tag,
        ...pick(date, ["date", "formattedDate"]),
        percentTagged: percentageFormatter(get(date, ["tags", tag, "percentTagged"]) / 100),
        percentUntaggedEquities: percentageFormatter(get(date, ["tags", tag, "percentUntaggedEquities"]) / 100),
        untaggedSecurities: get(date, ["tags", tag, "untaggedSecurities"]),
      })))
      .flatten()
      .value()
    return rows
  },
)
